/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Catalogservice.ts
 */

import KareviAPIService from "../tools/service/KareviAPIService";
import Catalog from "../models/Catalog";
import QueryFilter from "../tools/model/pagination/Filters";
import {Listener} from "../tools/service/Service";
import {Selectable} from "../tools/model/form/Selectable";
import {PaginationFilters} from "../tools/pagination/PaginationFilters";

export default class CatalogService extends KareviAPIService<Catalog, Listener<Catalog>> {
    public static SINGLE_ROUTE = '/catalog/{catalogId}';
    public static VIDEO_IN_CATALOG = '/catalog/{catalogId}/video/{videoId}';
    public static LIST_ROUTE = '/catalogs';
    public static id = "CatalogService";

    public static convertToSelectable(catalogs: Array<Catalog>): Array<Selectable<Catalog>> {
        let result: Array<Selectable<Catalog>> = [];

        for (let catalog of catalogs) {
            result.push({
                value: catalog,
                name: catalog.title,
                disabled: false
            })
        }

        return result;
    }

    /**
     * start
     */
    public start() {
        super.start();
    }

    /**
     * stop
     */
    public stop() {
        super.stop();
    }

    /**
     * createCatalog
     * @return {Promise<Catalog>}
     * @param dto
     */
    public async createCatalog(dto: Map<string, any> | FormData): Promise<Catalog> {
        return await this.post(CatalogService.LIST_ROUTE, dto);
    }

    /**
     * updateCatalog
     * @return {Promise<Catalog>}
     * @param dto
     * @param catalog
     */
    public async updateCatalog(catalog: Catalog, dto: Map<string, any> | FormData): Promise<Catalog> {
        const route = this.httpService.buildRoute(CatalogService.SINGLE_ROUTE, {
            catalogId: catalog.id
        });

        return await this.put(route, dto);
    }

    /**
     * findById
     * @returns {Promise<void>}
     */
    public async findById(id: string): Promise<Catalog> {
        const route = this.httpService.buildRoute(CatalogService.SINGLE_ROUTE, {
            catalogId: id
        });

        return await this.getOne<Catalog>(route);
    }

    /**
     * findAll
     * @returns {Promise<Catalog[]>}
     */
    public async findAll(): Promise<Catalog[]> {
        const catalogFilters: QueryFilter<PaginationFilters> = new QueryFilter<PaginationFilters>({
            page: 0,
            size: 10000
        });

        return await this.getList<Catalog, PaginationFilters>(CatalogService.LIST_ROUTE, catalogFilters);
    }
}
